.s-gifting-steps-wrapper {
  transition: .2s cubic-bezier(.55, 0, .1, 1) 0s;
}

.s-gifting-select{
  background-image: url("data:image/svg+xml;utf8,<svg version='1.1' fill='gray' xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'><title>keyboard_arrow_down</title><path d='M9.875 11.104l6.125 6.125 6.125-6.125 1.875 1.875-8 8-8-8z'></path></svg>");
  background-size: 24px;
  background-repeat: no-repeat;
  background-position: 99%;
  appearance: none;
}
// dir rtl
[dir=rtl] .s-gifting-select{
  background-position: 5px;
}